import React, {useState, useRef, useEffect} from "react"
import "./ProfileSettings.css"
import {Link} from "react-router-dom"
import BackgroundImage from "../../assets/img/recruitment-homepage-images/background.png";
import Logo from "../../assets/img/logo/logo.png";
import LogInWithLogo from "../../assets/img/logIn/Login-fotografija.png"
import {getResource, getByIdResource} from "../service/http-service";
import {DateLabelFormatter} from "../ui/DateLabelFormatter";
import ConsentsSettingsModal from "../ui/ConsentsSettingsModal";

export const ProfileSettings = () => {

    const [candidate, setCandidate] = useState({});
    const [updateCandidate, setUpdateCandidate] = useState(false);
    const [deleteRequest, setDeleteRequest] = useState({})


    const LoginRef = useRef(null);

    const goToLoginForm = () =>
        window.scrollTo({
            top: LoginRef.current.offsetTop,
            behavior: "auto",
        });


    useEffect(() => {
        const isPasswordChanged = sessionStorage.getItem('changePassword')
        if (isPasswordChanged === 'true') {
            window.location.replace("/career_opportunities/change_password")
        } else {
            getResource('candidates/get_logged_user_candidate').then(data => {
                setCandidate(data.data)
                getResource('profile_delete_requests/get_by_candidate').then(data => {
                    setDeleteRequest(data.data);
                })
            })
        }

    }, [])

    useEffect(() => {
        getResource('candidates/get_logged_user_candidate').then(data => {
            setCandidate(data.data)
            getByIdResource('profile_delete_requests/get_by_candidate', data.data.id).then(data => {
                setDeleteRequest(data.data);
            })
        })
    }, [updateCandidate])


    return (
        <div className="container-fluid m-0 p-0 profile-settings-container">
            {candidate &&
                <>
                    <div className="row m-0 p-0 backgroundImage">
                        <img src={BackgroundImage} className="backgroundImage m-0 p-0" alt="background-image"
                             onLoad={() => goToLoginForm()}/>
                        <div className="col-md-10 offset-md-1 col-12">
                            <div className="row m-0 p-0">
                                <div className="col-md-4 col-10 main-title">
                                    ПОДЕСУВАЊА ЗА ПРИВАТНОСТ
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mx-3 p-0">
                        <div className="col-md-10 offset-md-1 p-0 logIn-container">
                            <img src={Logo} className="logIn-logo"/>
                            <div className="logIn-content" style={{backgroundImage: `url(${LogInWithLogo})`}}>
                                       <div className="profile-settings-inner">
                                           <p> Со цел да се овозможи законита и транспарентна обработка на Вашите податоци во процесот
                                               на регрутација - евалуација и селекција на кандидати за вработување/практиканство и
                                               Ваше запознавање со начинот на кој постапуваме со Вашите лични податоци, потребно е
                                               детално да ја прочитате <b> Информацијата за приватност за кандидатите за вработување и
                                               практиканство на АЛКАЛОИД, </b> која е поставена на следниот
                                               <a id="policyLink" href="https://alkaloid.com.mk/mk/zashtita-na-lichni-podatoci" target='_blank'> линк</a></p>
                                           <h3>Согласност за чување на податоци:</h3>
                                           {candidate.consentForDataProcessingForOneAd &&
                                               <div>
                                                   <h5>Тип на согласност</h5>
                                                   <p>Се согласувам моите лични податоци и приложената документација да се обработуваат и чуваат
                                                       исклучиво за времетраење на процесот на евалуација и селекција на кандидати за вработување
                                                       и избор на нови вработени за соодветната работна позиција за која аплицирам.</p>
                                                   <h5>Датум на давање согласност: <DateLabelFormatter
                                                       dateString={candidate.consentForDataProcessingForOneAdDate}/></h5>
                                                 <div className="profile-settings-inner-flex">
                                                     <h5>Согласност за чување на податоци во наредните 3 години</h5>
                                                     <ConsentsSettingsModal
                                                         modalBtn="profile-settings-button"
                                                         btnText='Согласност за наредни 3 години'
                                                         btnClass="apply-btn"
                                                         url='candidates/change_consent_to_permanent'
                                                         modalTitle='Согласност за чување на податоци во наредните 3 години'
                                                         modalBody="Се согласувам моите лични податоци и приложената документација да се
                                                          обработуваат и чуваат во рок од три (3) години од денешниот датум, а со цел учество во
                                                          процесот на евалуација и селекција на кандидати за вработување/кандидати за практиканти
                                                          при отворања на идни работни позиции/позиции за практиканти во Алкалоид АД Скопје и
                                                          капитално поврзаните друштва Алкалоид КОНС и АЛКАЛОИД Билна аптека."
                                                         setUpdateEntities={setUpdateCandidate}
                                                         updateEntities={updateCandidate}/>
                                                 </div>
                                               </div>

                                           }
                                           {candidate.consentForKeepingDataThreeYears &&
                                               <div>
                                                   <h5>Тип на согласност</h5>
                                                   <p>Се согласувам моите лични податоци и приложената документација да се обработуваат
                                                       и чуваат во рок од три (3) години од датумот на аплицирање, а со цел учество во процесот
                                                       на евалуација и селекција на кандидати за вработување/кандидати за практиканти при отворање на
                                                       идни работни позиции/позиции за практиканти во Алкалоид АД Скопје и капитално поврзаните друштва
                                                       АЛКАЛОИД КОНС и АЛКАЛОИД Билна аптека. </p>
                                                   <h5>Датум на давање согласност: <DateLabelFormatter
                                                       dateString={candidate.consentForKeepingDataThreeYearsDate}/></h5>
                                                 <div className="profile-settings-inner-flex">
                                                     <h5>Продолжување на согласност за чување на податоците во наредни 3 години</h5>
                                                         <ConsentsSettingsModal
                                                             modalBtn="profile-settings-button"
                                                             btnText='Продолжи'
                                                             btnClass="apply-btn"
                                                             url='candidates/change_consent_to_permanent'
                                                             modalTitle='Продолжување на согласност за чување на податоците во наредни 3 години'
                                                             modalBody='Се согласувам моите лични податоци и приложената документација да се
                                                             обработуваат и чуваат во рок од уште три (3) години од денешниот датум, а со цел учество во
                                                              процесот на евалуација и селекција на кандидати за вработување/кандидати за практиканти при
                                                              отворања на идни работни позиции/позиции за практиканти во Алкалоид АД Скопје и капитално
                                                              поврзаните друштва Алкалоид КОНС и АЛКАЛОИД Билна аптека.'
                                                             setUpdateEntities={setUpdateCandidate}
                                                             updateEntities={updateCandidate}/>
                                                 </div>
                                               </div>
                                           }
                                           <h5>Барање за повлекување на согласноста за чување на личните податоци</h5>
                                           {deleteRequest &&
                                               <div>
                                                   <h5>Креиравте барање за повлекување на согласноста за чување на личните податоци на
                                                       датум: <DateLabelFormatter dateString={deleteRequest.dateRequested}/></h5>
                                                   <h5>Вашите податоци ќе бидат избришани.</h5>
                                               </div>
                                           }
                                           {!deleteRequest &&
                                               <div>
                                                       <ConsentsSettingsModal
                                                           modalBtn="profile-settings-button"
                                                           btnText="Повлечи"
                                                           btnClass="apply-btn"
                                                           url='candidates/request_to_be_deleted'
                                                           modalTitle='Барање за повлекување на согласноста за чување на личните податоци '
                                                           modalBody='Ве известувам дека ја повлекувам согласноста за обработка на моите лични
                                                           податоци кои се дадени со цел учество во процесот на евалуација и селекција на кандидати за
                                                           вработување/кандидати за практиканти при отворања на идни работни позиции/позиции за практиканти
                                                           во Алкалоид АД Скопје и капитално поврзаните друштва Алкалоид КОНС и АЛКАЛОИД Билна аптека.'
                                                           footerText="Доколку го потврдите барањето за повлекување на согласноста за обработка на вашите лични податоци,
                                                           истите ќе бидат избришани. "
                                                           setUpdateEntities={setUpdateCandidate}
                                                           updateEntities={updateCandidate}/>
                                               </div>
                                           }
                                       </div>
                            </div>
                            <div ref={LoginRef} className="white-space"></div>
                        </div>
                    </div>
                </>
            }
        </div>
    )
};